import request from "@/plugins/request"

// yoyo币签到
export const signInYoyoCoin = () => {
  return request({
    url: "app-api/member/sign-in/record/create",
    method: "post",
  })
}

// 获取yoyo币记录
export const getPointRecord = (params) => {
  return request({
    url: "app-api/member/point/record/page",
    method: "get",
    params,
  })
}

// 我的优惠券列表
export const getCouponList = (params) => {
  return request({
    url: "app-api/promotion/coupon/page",
    method: "get",
    params,
  })
}


// 我的评论列表
export const getCommentPage = (params) => {
  return request({
    url: "app-api/trade/order/commentPage",
    method: "get",
    params,
  })
}
// 获取评论标签列表
export const getCommentTagList = (params) => {
  return request({
    url: "app-api/zb/configTag/list",
    method: "get",
    params,
  })
}
// 评论
export const addComment = (data) => {
  return request({
    url: "app-api/trade/order/item/create-comment",
    method: "post",
    data,
  })
}

//徽章等级
export const getLevelList = (params) => {
  return request({
    url: "app-api/member/level/list",
    method: "get",
    params,
  })
}

// 获取绑定列表
export const getBindingList = (params) => {
  return request({
    url: "app-api/trade/tradeOrderIcItem/page",
    method: "get",
    params,
  })
}

// 添加绑定
export const addBinding = (data) => {
  return request({
    url: "app-api/trade/tradeOrderIcItem/bind",
    method: "post",
    data,
  })
}

// 删除绑定
export const deleteBinding = (data) => {
  return request({
    url: `app-api/trade/tradeOrderIcItem/cancelBind`,
    method: "delete",
    params: data,
  })
}

// 查询流量
export const queryUsage = (data) => {
  return request({
    url: "app-api/trade/tradeOrderIcItem/queryUsage",
    method: "get",
    params: data,
  })
}

// 获取代办
export const getTodoList = (params) => {
  return request({
    url: "app-api/user/getTodo",
    method: "get",
    params,
  })
}